<template>
<div class="chapter">
<div class="inner_page">
<div id="a13_part1">
<a id="page_1">
<p class="part">PART I</p>
<p class="parttitle">The Battle of Jutland</p>
<p class="parttitlea">31 May—1 June 1916</p>
</a></div><a id="page_1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 13_part1.vue?62fac830